import api from ".";
import { ICriteria } from "../types/criteria";
import cookiesModifier from "../utils/cookies";

export const createCriteria = async (data: ICriteria) => {
    const url = `criterias`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateCriteria = async (data: ICriteria) => {
    try {
        const { id, ...payload } = data;
        const url = `criterias/${id}`;
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(url, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteCriteria = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`criterias/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}